export default "__VITE_ASSET__CQc9a9D7__"